import { Box } from '@mantine/core';
import type { ComponentProps, FC, ReactNode } from 'react';

import { EventPreview as EventPreviewPanel } from '../../components/global/EventPreview/EventPreview.tsx';

interface EventPreviewProps {
  eventPreviewData: ComponentProps<typeof EventPreviewPanel>;
  footerContent?: ReactNode;
}

export const EventPreview: FC<EventPreviewProps> = ({ eventPreviewData, footerContent }) => {
  return (
    <Box bg="gigi-white" style={{ borderRadius: 24, overflow: 'hidden' }}>
      <Box>
        <EventPreviewPanel {...eventPreviewData} />
      </Box>

      {footerContent}
    </Box>
  );
};
